import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NotificationsService } from 'angular2-notifications';
import { Router } from '@angular/router';
import { apiUrl, WISHLISTVIEW, WISHLISTADD, WISHLISTDELETE, CARTADD, CARTVIEW, CARTDELETE, CARTUPDATE, ORDERHISTORY, PROFILEVIEW, GETADDRESS  } from './config';
import * as CryptoJS from 'crypto-ts';
@Injectable({
  providedIn: 'root'
})
export class ApiService {
  @Output() getlogin:EventEmitter<number> = new EventEmitter();
  @Output() getWish:EventEmitter<string> = new EventEmitter();
  @Output() getUserData:EventEmitter<string> = new EventEmitter();
  @Output() Cart:EventEmitter<string> = new EventEmitter();
  @Output() filterChange:EventEmitter<string> = new EventEmitter();

  goto: any;
  drop:any;
  otp:any;
  otpGuard:any;
  uid:any;
  wish:any[];
  event:any;
  header:any;
  filter:any;
  state: any;
  addresses: any;
  igst = false;
  heartLoader:any = false;
  constructor(public http: HttpClient,private service: NotificationsService, private router: Router) {
    this.filter = {"menu":{"jewelery_for":[],"jewelery_type":[],"material":[],"price":{},"purity":[]}};
    this.header = new HttpHeaders().set(
      "Authorization",
       'Bearer'+" "+this.getMobileNo()
    );



https://pincode.saratchandra.in/api/pincode/742212







    if(localStorage.getItem('savya_userInfo'))
    {
     let u=this.getUserInfo();
    this.uid=u.id;
    console.log("userid"+this.uid);
   }
    if (localStorage.getItem('drop')) {
      this.updateIgst();
      this.drop =  +this.decrypt((localStorage.getItem('drop')));
    } else {
      this.drop = 0;
    }
    this.getlogin.subscribe(data=>{
      if(this.drop==1)
      {
        console.log('HERE');
        this.updateIgst();

        if(localStorage.getItem('savya_userInfo'))
        {
          this.updateCart();
          this.updateWishlist();
          this.updateOrderHistory();
        }
        console.log("login emitter");
      }
      if(this.drop==0)
      {
        console.log("logout emitter");
      }

    })
  }
  public Getgst(pincode) {
    return new Promise((resolve, reject) => {
      this.http.get('https://pincode.saratchandra.in/api/pincode/'+pincode)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  updateIgst(){
    this.Get(GETADDRESS).then(data => {
      this.addresses = data['data'];
      this.addresses = this.addresses[0];
      console.log(this.addresses);
      this.state = this.Getgst(this.addresses.pincode);
      setTimeout(() => {

        this.state = this.state.__zone_symbol__value?.data[0]?.state_name;

      console.log(this.state);
      if(this.state.toUpperCase() == 'MAHARASHTRA'){
        console.log(this.state.toUpperCase());
        this.igst = false;

      } else{
        console.log('other');
       this.igst = false;
      }
      },1000);});
  }

  public Get(api) {
    this.header = new HttpHeaders().set(
      "Authorization",
       'Bearer'+" "+this.getMobileNo()
    );
   // console.log(this.header);
    return new Promise((resolve, reject) => {
      this.http.get(apiUrl + api,  {headers:this.header})
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }
  
  public GetWithId(api, formData) {
    this.header = new HttpHeaders().set(
      "Authorization",
       'Bearer'+" "+this.getMobileNo()
    );
   // console.log(this.header);
    return new Promise((resolve, reject) => {
      this.http.get(apiUrl + api+'/'+ formData, {headers:this.header})
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  public Delete(api){
    return new Promise((resolve, reject) => {
      this.http.delete(apiUrl + api,  {headers:this.header})
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }
  public Put2(api, formData,parameters={}){
    this.header = new HttpHeaders().set(
      "Authorization",
       'Bearer'+" "+this.getMobileNo()
    );
    console.log(this.header);
    return new Promise((resolve, reject) => {

      let options = { headers: this.header ,params:parameters};

      this.http.put(apiUrl + api+formData,formData,options)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }
  public Post(api, formData) {
    return new Promise((resolve, reject) => {
      this.http.post(apiUrl + api, formData,  {headers:this.header})
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }
  public Post2(api, formData,parameters?) {
    return new Promise((resolve, reject) => {
      this.http.post(apiUrl + api, formData,  {headers:this.header,params:parameters})
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  public Put(api, formData,parameters={}) {
    return new Promise((resolve, reject) => {

      let options = { headers: this.header ,params:parameters};

      this.http.put(apiUrl + api+'/'+formData,formData,options)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  public Put3(api, formData,parameters={}) {
    return new Promise((resolve, reject) => {

      let options = { headers: this.header ,params:parameters};

      this.http.put(apiUrl + api+'/'+formData+ "?user_id="+this.uid,formData,options)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  public delete(api, formData) {
    return new Promise((resolve, reject) => {

      let options = { headers: this.header};

      this.http.delete(apiUrl + api+'/'+formData,options)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  setGoto(){
    this.goto = this.router.url;
  }

  getGoto(){
    if(this.goto){
      this.router.navigate([this.goto]);
    }
    this.goto = null;
  }

  onSuccess(message,title){
    console.log('hello');
    this.service.success(title,message,{
     position:["middle","center"],
      timeOut: 3000,
      showProgressBar: true,
      pauseOnHover: true,
      clickToClose: true
    });
  }

  onFail(message,title){
    this.service.warn(title,message,{
     position:  	["middle","center"],
      timeOut: 3000,
      showProgressBar: true,
      pauseOnHover: true,
      clickToClose: true
    });
  }

  setMobileNo(value)
  {
    localStorage.setItem('token',value);


      this.updateIgst();

  }
  getMobileNo()
  {
    let m=localStorage.getItem('token');
    // let d =this.decrypt(m);
    //  return d;
    return m;

  }
  setlogin(value)
  {
          let e=this.encrypt(value);
          localStorage.setItem('drop',e);
          this.drop=this.decrypt(e);
        this.getlogin.emit(this.drop);

  }
    getUserInfo()
    {
      if(localStorage.getItem('savya_userInfo')){
      let d =this.decrypt(localStorage.getItem('savya_userInfo'));
      console.log(d);
      return d;
    }
    }
    logout()
    {
        this.header = null;

        localStorage.removeItem('savya_userInfo');
        localStorage.removeItem('token');
        localStorage.removeItem('wishlist');
        localStorage.removeItem('cart');
        localStorage.removeItem('orders');
    }
  setOtp(value)
  {
   this.otp=value;
  }
  getOtp()
  {
    return this.otp;
  }
  setOtpGuard(value)
  {
      this.otpGuard=value;
     // console.log("apiservice"+this.otpGuard);
  }
  getOtpGuard()
  {
    //console.log("apiservice"+this.otpGuard);
      return this.otpGuard;

  }

  calculateFilter(products,pric,igst=false){
    console.log('IN API');
    let productlist = products;
    let price = pric;
    let priceWeight = [];
    let fault = 1;
    let i = 0
    productlist.forEach(childObj => {
     let off = 0
     let tax = 0,
    fault = 1;
    let assests = childObj.assets;
    
    console.log(assests);
    if(childObj.price_type == "Manually"){assests = []}
    let gold = childObj.assets.find(slide => slide.metrial_type === 'Gold');
    let silver = childObj.assets.find(slide => slide.metrial_type === 'Silver');
    let stone = childObj.assets.find(slide => slide.metrial_type === 'STONE');
    let diamond = childObj.assets.filter(slide => slide.metrial_type === 'Diamond');
    let platinum = childObj.assets.find(slide => slide.metrial_type === 'Platinum');
    let black = childObj.assets.find(slide => slide.metrial_type === 'BEATS');
    let kundan = childObj.assets.find(slide => slide.metrial_type === 'Kudan');
    let gram = childObj.assets.find(slide => slide.metrial_type === '1 Gram');
    let ade = childObj.assets.filter(slide => slide.metrial_type === 'ADE');
    console.log(diamond);
    if(diamond && diamond.length){
      console.log(diamond)
      if(diamond.find(x => x.diamond_index==1)){
      diamond[0] = diamond.find(x => x.diamond_index==1);
      console.log(diamond[0]);}

      if(diamond.find(x => x.diamond_index==1)){
      diamond[1] = diamond.find(x => x.diamond_index==2);
      }
    }
    let weight = 0;
    let priceProduct = 0;
    let making = 0;
    let goldweight;

    if(gold)  {
        if(gold.charges_option == 'Percentage'){
          let pricegold = price.Gold.find(x => x.type == '24KT');
          let value = price.Gold.find(x => x.type == gold.jwellery_size);
          value = value.value_in;
          if(pricegold){
          let outcome = this.price(gold.weight,pricegold.price,gold.charges_option,gold.making_charge,0,value);
              weight += Number(gold.weight);
              goldweight = Number(outcome.weight);
              priceProduct += outcome.price;
            }else{
              console.log(i + 'gold');
                fault = 0;
            }

        } else {

          let pricegold = price.Gold.find(x => x.type == gold.jwellery_size);
          if(pricegold){
          let outcome = this.price(gold.weight,pricegold.price,gold.charges_option,gold.making_charge,gold.wastage,0,gold.quantity);
          weight += Number(gold.weight);
          goldweight = Number(outcome.weight);
          priceProduct += outcome.price;
          }else{
            console.log(i + 'gold');
            fault = 0;
          }
        }
    }

    

    if(silver)  {
      //READY GOODS
      let pricesilver = price.Silver.find(x => x.type == silver.jwellery_size);
   //   console.log(pricesilver);

      if(pricesilver)
      {
            let outcome = this.price(silver.weight,pricesilver.price,silver.charges_option,silver.making_charge,0,0,silver.quantity);
            weight += Number(silver.weight);
         //   console.log(i + 'silver');
            priceProduct += outcome.price;
            making += Number(outcome.making_charge);
      }
      else
      {
            console.log(i + 'silver');
            console.log(pricesilver);
            fault = 0;
      }
    }
    
    if(stone)  {
      let pricestone = price.STONE.find(x => x.type == stone.jwellery_size);
      if(pricestone){
      let outcome = this.price(stone.weight,pricestone.price,stone.charges_option,stone.making_charge,stone.wastage,0,stone.quantity);
      weight += Number(stone.weight);
      priceProduct += outcome.price;
      making += Number(outcome.making_charge);}
      else  {
        console.log(i + 'stone');
        fault = 0;
      }
    }

    if(diamond){
      if(diamond.length > 0){
        diamond.forEach((res)=>{
          if(res){
            let pricediamond = price.Diamond.filter(x => x.diamond_type == res.jwellery_size);
            pricediamond = pricediamond.find(x => x.type == res.default_color_clarity);
            if(pricediamond){
              let outcome = this.price(res.weight,pricediamond.price,res.charges_option,res.making_charge,res.wastage,0,res.quantity);
              weight += Number(outcome.weight)*0.2;
              priceProduct += outcome.price;
              making += Number(outcome.making_charge);
            }else{
              console.log(i + 'diamond');
              // fault = 0;
            }
          }
        })
      }
    }

   console.log(weight , '###diamond weight');
   console.log(priceProduct , '###diamond priceProduct');
   console.log(making , '###diamond making');
    
    // if(diamond[0])  {
    //     let pricediamond = price.Diamond.filter(x => x.diamond_type == diamond[0].jwellery_size);
    //     pricediamond = pricediamond.find(x => x.type == diamond[0].default_color_clarity);
    //     if(pricediamond){
    //     let outcome = this.price(diamond[0].weight,pricediamond.price,diamond[0].charges_option,diamond[0].making_charge,diamond[0].wastage,0,diamond[0].quantity);
    //     weight += Number(outcome.weight)*0.2;
    //     priceProduct += outcome.price;
    //     console.log("priceProduct af Diamond [0]",   outcome.price)
    //     making += Number(outcome.making_charge);
    //   }
    //   else{
    //     console.log(i + 'diamond');
    //     fault = 0;
    //   }
    // }
    
    // if(diamond[1])  {
    //   let pricediamond = price.Diamond.filter(x => x.diamond_type == diamond[1].jwellery_size);
    //   pricediamond = pricediamond.find(x => x.type == diamond[1].default_color_clarity);
    //   if(pricediamond){
    //   let outcome = this.price(diamond[1].weight,pricediamond.price,diamond[1].charges_option,diamond[1].making_charge,diamond[1].wastage,0,diamond[1].quantity);
    //   weight += Number(outcome.weight)*0.2;
    //   priceProduct += outcome.price;
    //   console.log("priceProduct af  Diamond [1] ",  outcome.price)
    //   making += Number(outcome.making_charge);}else{
    //     console.log(i + 'diamond');
    //    fault = 0;
    //   }
    // }
    

    if(platinum)  {

      let priceplatinum = price.Platinum.find(x => x.type == platinum.jwellery_size);
      if(priceplatinum){
      let outcome = this.price(platinum.weight,priceplatinum.price,platinum.charges_option,platinum.making_charge,0,0,platinum.quantity);
      weight += Number(platinum.weight);
      priceProduct += outcome.price;
      making += Number(outcome.making_charge);}else{
        console.log(i + 'platinum');
        fault = 0;
      }
    }
    
    if(black)  {
      let priceblack = price.BEATS.find(x => x.type == black.jwellery_size);
      if(priceblack){
      let outcome = this.price(black.weight,priceblack.price,black.charges_option,black.making_charge,black.wastage,0,black.quantity);
      weight += Number(black.weight);
      priceProduct += outcome.price;
      making += Number(outcome.making_charge);
    }else{
        console.log(i + 'black');
        fault = 0;
      }
    }
    
    if(gram)  {
      let pricegram = price['1 Gram'].find(x => x.type == gram.jwellery_size);
      if(pricegram){
      let outcome = this.price(gram.weight,pricegram.price,gram.charges_option,gram.making_charge,gram.wastage,0,gram.quantity);
      weight += Number(gram.weight);
      priceProduct += outcome.price;
      making += Number(outcome.making_charge);}else{
        console.log(i + 'gram');

        fault = 0;
      }
    }
    
    if(kundan)  {
      let pricekundan = price.Kudan.find(x => x.type == kundan.jwellery_size);
      if(pricekundan){
      let outcome = this.price(kundan.weight,pricekundan.price,kundan.charges_option,kundan.making_charge,kundan.wastage,0,kundan.quantity);

      weight += Number(kundan.weight);
      priceProduct += outcome.price;
      making += Number(outcome.making_charge);}else{
        console.log(i + 'kundan');
        fault = 0;
      }
    }
    
    if(ade)  {
      if(ade?.length > 0){ 
        ade.forEach((res)=>{ 
          if(res){
            console.log("####res", res);
            let priceade = price.ADE.find(x => x.type == res.jwellery_size);
            if(priceade){
              let outcome = this.price(res.weight,priceade.price,res.charges_option,res.making_charge,res.wastage,0,res.quantity);
              weight += Number(outcome.weight);
              priceProduct += outcome.price;
              making += Number(outcome.making_charge);
            }
          }
        })
      }
    }

    let saveMoney = 0;
    
    if(assests.length==0){
      if(childObj.offer_type == 'Percentage')
      {
        off = Number(childObj.amount)-Number(childObj.amount*0.01*childObj.offer_amount);
        saveMoney = Number(childObj.amount*0.01*childObj.offer_amount);
      }else if(childObj.offer_type == "Flat")
      {
        off = Number(childObj.amount) - Number(childObj.offer_amount);
        saveMoney = Number(childObj.offer_amount);
      }
      if(childObj.offer_type == 'Percentage' || childObj.offer_type == 'Flat'){
      if(!igst  && childObj.CGST && childObj.SGST){
        off = Number(off) + Number(off * 0.01 * childObj.CGST)+ Number(off * 0.01 * childObj.SGST);
        tax = Number(childObj.amount * 0.01 * childObj.CGST) +  Number(childObj.amount * 0.01 * childObj.SGST);
        childObj.amount = Number(childObj.amount) + Number(tax) ;

      }else if(childObj.IGST){
        off = Number(off) + Number(off * 0.01 * childObj.IGST);
        tax = Number(childObj.amount * 0.01 * childObj.IGST);
        console.log(igst);
        childObj.amount = Number(childObj.amount) + Number(tax);

      }
    } else{
      if(!igst  && childObj.CGST && childObj.SGST){


        off = Number(off) + Number(off * 0.01 * childObj.CGST)+ Number(off * 0.01 * childObj.SGST);
        tax = Number(childObj.amount * 0.01 * childObj.CGST) +  Number(childObj.amount * 0.01 * childObj.SGST);
        childObj.amount = Number(childObj.amount)+ Number(childObj.amount * 0.01 * childObj.CGST)+ Number(childObj.amount * 0.01 * childObj.SGST);

      }else if(childObj.IGST){
        off = Number(off) + Number(off * 0.01 * childObj.IGST);
        tax = Number(childObj.amount * 0.01 * childObj.IGST);
        console.log(igst);
        childObj.amount = Number(childObj.amount) + Number(childObj.amount * 0.01 * childObj.IGST);

      }
    }

      let data = {'weight':0,'price':childObj.amount,'goldcat':'','goldweight':0,'making':0,'off':off, "saveMoney":saveMoney};
      priceWeight.push(data);
    } else if(fault!=0 && assests.length != 0){
      priceProduct = Math.round(priceProduct);
      if(childObj.offer_type == 'Percentage')
      {
        off = Number(priceProduct)-Number(priceProduct*0.01*childObj.offer_amount);
        saveMoney = Number(priceProduct*0.01*childObj.offer_amount);
      }else if(childObj.offer_type == "Flat")
      {
        off = Number(priceProduct) - Number(childObj.offer_amount);
        saveMoney = Number(childObj.offer_amount);
      }
      if(childObj.offer_type == "Flat" || childObj.offer_type == "Percentage"){
      if(!igst && childObj.CGST && childObj.SGST){
        off = Number(off) + Number(off * 0.01 * childObj.CGST)+ Number(off * 0.01 * childObj.SGST);
        tax = Number(priceProduct * 0.01 * childObj.CGST) +  Number(priceProduct * 0.01 * childObj.SGST);
        priceProduct = Number(priceProduct) + Number(tax);
      }else if(childObj.IGST){
        off = off + Number(off * 0.01 * childObj.IGST);
        tax = Number(priceProduct * 0.01 * childObj.IGST);
        priceProduct = Number(priceProduct) + Number(tax);
      }}else{
        if(!igst && childObj.CGST && childObj.SGST){
          off = Number(off) + Number(off * 0.01 * childObj.CGST)+ Number(off * 0.01 * childObj.SGST);
          tax = Number(priceProduct * 0.01 * childObj.CGST) +  Number(priceProduct * 0.01 * childObj.SGST);
          priceProduct = Number(priceProduct) + Number(priceProduct * 0.01 * childObj.CGST) +  Number(priceProduct * 0.01 * childObj.SGST);
        }else if(childObj.IGST){
          off = off + Number(off * 0.01 * childObj.IGST);
          tax = Number(priceProduct * 0.01 * childObj.IGST);
          priceProduct = Number(priceProduct) + Number(priceProduct * 0.01 * childObj.IGST);
        }
      }



      if(gold){
        let data = {'weight':weight.toFixed(3)+'g','price':off + saveMoney,'goldcat':gold.jwellery_size,'goldweight':goldweight,'making':making,'off':off, "saveMoney":saveMoney};
        priceWeight.push(data);}
        else{

          let data = {'weight':weight.toFixed(3)+'g','price':off + saveMoney,'goldcat':'','goldweight':0,'making':making,'off':off, "saveMoney":saveMoney};
        priceWeight.push(data);
      }
    } else{

      console.log('Its not 00 and no fault');
      if(gold){
        let data = {'weight':fault,'price':fault,'goldcat':gold.jwellery_size,'goldweight':goldweight,'making':fault,'off':off, "saveMoney":saveMoney};
        priceWeight.push(data);}
        else{
          let data = {'weight':fault,'price':fault,'goldcat':'','goldweight':0,'making':fault,'off':off, "saveMoney":saveMoney};
        priceWeight.push(data);}
    }
    i++;
    });
    console.log("Price Info",priceWeight);
    return priceWeight;
  }


  calculatePercentage(value: number, percentage: number): number {
    return Number((value * percentage) / 100) 
  }


  calculate(products,igst=false){
    console.log('IN API');
    let priceWeight = [];

    console.log(products);
    products.forEach(childObj => {

        console.log('HAVE LENGTH');
        console.log('#####childObj', childObj);
        let assests = childObj.assests;
    let gold = childObj.assests.find(slide => slide.metal === 'Gold');
    let silver = childObj.assests.find(slide => slide.metal === 'Silver');
    let stone = childObj.assests.find(slide => slide.metal === 'STONE');
    let diamond = childObj.assests.filter(slide => slide.metal === 'Diamond');
    let platinum = childObj.assests.find(slide => slide.metal === 'Platinum');
    let black = childObj.assests.find(slide => slide.metal === 'BEATS');
    let kundan = childObj.assests.find(slide => slide.metal === 'Kudan');
    let gram = childObj.assests.find(slide => slide.metal === '1 Gram');
    let ade = childObj.assests.filter(slide => slide.metal === 'ADE');
    let price = childObj.price;
    let weight = 0;
    let off = 0;
    let priceProduct = 0;
    let offtax = 0;
    let tax = 0;
    let making = 0;
    let goldweight;
    let iigst = 0;
    let sgst = 0;
    let cgst = 0;
    let oigst = 0;
    let osgst = 0;
    let ocgst = 0;

    if(gold)  {
        if(gold.options == 'Percentage'){
          let pricegold = price.Gold.find(x => x.type == '24KT');
          let value = price.Gold.find(x => x.type == gold.materialType);
          value = value.value_in;
          let outcome = this.price(gold.weight,pricegold.price,gold.options,gold.makingCharge,0,value);
              weight += Number(outcome.weight);
              goldweight = Number(gold.weight);
              making += Number(outcome.making_charge);
              priceProduct += outcome.price;
              console.log("priceProduct af gold", outcome.price)
        } else {
          let pricegold = price.Gold.find(x => x.type == gold.materialType);
          let outcome = this.price(gold.weight,pricegold.price,gold.options,gold.makingCharge,gold.wastage);
          weight += Number(gold.weight);
          goldweight = Number(outcome.weight);
          priceProduct += outcome.price;
          making += Number(outcome.making_charge);
          console.log("priceProduct af gold", outcome.price)
        }
        
    }
    if(silver)  {
      let pricesilver = price.Silver.find(x => x.type == silver.materialType);
      let outcome = this.price(silver.weight,pricesilver.price,silver.options,silver.makingCharge,0,0,silver.quantity);
      weight += Number(silver.weight);
      priceProduct += outcome.price;
      making += Number(outcome.making_charge);
      console.log("priceProduct af silver",  outcome.price)
    }
    if(stone)  {
      let pricestone = price.STONE.find(x => x.type == stone.materialType);
      let outcome = this.price(stone.weight,pricestone.price,stone.options,stone.makingCharge,stone.wastage,0,stone.quantity);
      weight += Number(stone.weight);
      priceProduct += outcome.price;
      making += Number(outcome.making_charge);
      console.log("priceProduct af stone", outcome.price)
    }

    if(diamond){
      console.log("####diamond", diamond)
      if(diamond.length > 0){
        diamond.forEach((res)=>{
          if(res){
            let pricediamond = price.Diamond.filter(x => x.diamond_type == res.jwellery_size);
            pricediamond = pricediamond.find(x => x.type == res.default_color_clarity);
            if(pricediamond){
              let outcome = this.price(res.weight,pricediamond.price,res.charges_option,res.making_charge,res.wastage,0,res.quantity);
              weight += Number(outcome.weight)*0.2;
              priceProduct += outcome.price;
              making += Number(outcome.making_charge);
              console.log("priceProduct af diamond", outcome.price)
            }else{
              // fault = 0;
            }
          }
        })
      }
    }

    // if(diamond[0])  {
    //   let pricediamond = price.Diamond.filter(x => x.diamond_type == diamond[0].diamondType);
    //   pricediamond = pricediamond.find(x => x.type == diamond[0].materialType);
    //   console.log(pricediamond);
    //   console.log(diamond[0]);
    //   let outcome = this.price(diamond[0].weight,pricediamond.price,diamond[0].options,diamond[0].makingCharge,diamond[0].wastage,0,diamond[0].quantity);
    //   console.log(outcome);
    //   weight += Number(outcome.weight)*0.2;
    //   priceProduct += outcome.price;
    //   making += Number(outcome.making_charge);
    // }
    // if(diamond[1])  {
    //   let pricediamond = price.Diamond.filter(x => x.diamond_type == diamond[1].diamondType);
    //   pricediamond = pricediamond.find(x => x.type == diamond[1].materialType);
    //   let outcome = this.price(diamond[1].weight,pricediamond.price,diamond[1].options,diamond[1].makingCharge,diamond[1].wastage,0,diamond[1].quantity);
    //   weight += Number(outcome.weight)*0.2;
    //   priceProduct += outcome.price;
    //   making += Number(outcome.making_charge);
    // }
    if(platinum)  {
      let priceplatinum = price.Platinum.find(x => x.type == platinum.materialType);
      let outcome = this.price(platinum.weight,priceplatinum.price,platinum.options,platinum.makingCharge,0,0,platinum.quantity);
      weight += Number(platinum.weight);
      priceProduct += outcome.price;
      making += Number(outcome.making_charge);
      console.log("priceProduct af platinum", outcome.price)
    }
    if(black)  {
      let priceblack = price.BEATS.find(x => x.type == black.materialType);
      let outcome = this.price(black.weight,priceblack.price,black.options,black.makingCharge,black.wastage,0,black.quantity);
      weight += Number(black.weight);
      priceProduct += outcome.price;
      making += Number(outcome.making_charge);
      console.log("priceProduct af beats", outcome.price)
    }
    if(gram)  {
      let pricegram = price['1 Gram'].find(x => x.type == gram.materialType);
      let outcome = this.price(gram.weight,pricegram.price,gram.options,gram.makingCharge,gram.wastage,0,gram.quantity);
      weight += Number(gram.weight);
      priceProduct += outcome.price;
      making += Number(outcome.making_charge);
      console.log("priceProduct af 1gram",  outcome.price)
    }
    if(kundan)  {
      let pricekundan = price.Kudan.find(x => x.type == kundan.materialType);
      let outcome = this.price(kundan.weight,pricekundan.price,kundan.options,kundan.makingCharge,kundan.wastage,0,kundan.quantity);
      weight += Number(kundan.weight);
      priceProduct += outcome.price;
      making += Number(outcome.making_charge);
      console.log("priceProduct af kundan",  outcome.price)
    }
    if(ade)  {
      if(ade?.length > 0){ 
        ade.forEach((res)=>{ 
          if(res){
            let priceade = price.ADE.find(x => x.type == res.jwellery_size);
            if(priceade){
              let outcome = this.price(res.weight,priceade.price,res.charges_option,res.making_charge,res.wastage,0,res.quantity);
              weight += Number(outcome.weight);
              priceProduct += outcome.price;
              making += Number(outcome.making_charge);
              console.log("priceProduct af ade", childObj?.product_name , outcome.price)
            }
          }
        })
      }
    }

    if(!assests.length){
      if(childObj.offer_type == 'Percentage')
      {

        off = Number(childObj.amount)-Number(childObj.amount*0.01*childObj.offer_amount);
      }else if(childObj.offer_type == "Flat")
      {
        off = Number(childObj.amount) - Number(childObj.offer_amount);
      }
      if(childObj.offer_type == "Flat" || childObj.offer_type == "Percentage")
      {
      if(!igst  && childObj.CGST && childObj.SGST){

        offtax =  Number(off * 0.01 * childObj.CGST)+ Number(off * 0.01 * childObj.SGST);
        ocgst = Number(off * 0.01 * childObj.CGST);
        osgst = Number(off * 0.01 * childObj.SGST);
        tax = Number(childObj.amount * 0.01 * childObj.CGST)+ Number(childObj.amount * 0.01 * childObj.SGST);
        cgst = Number(childObj.amount * 0.01 * childObj.CGST);
        sgst = Number(childObj.amount * 0.01 * childObj.SGST);
        off = Number(off) + Number(off * 0.01 * childObj.CGST)+ Number(off * 0.01 * childObj.SGST);
        childObj.amount = Number(childObj.amount);

      }else if(childObj.IGST){

        offtax = Number(off * 0.01 * childObj.IGST);

        tax = Number(childObj.amount * 0.01 * childObj.IGST);
        off = Number(off) + Number(off * 0.01 * childObj.IGST);
        oigst = Number(off * 0.01 * childObj.IGST);
        console.log(oigst);
        iigst = Number(childObj.amount * 0.01 * childObj.IGST);
        console.log(igst);
        childObj.amount = Number(childObj.amount);

      }
    } else{
      if(!igst  && childObj.CGST && childObj.SGST){

        offtax =  Number(off * 0.01 * childObj.CGST)+ Number(off * 0.01 * childObj.SGST);
        ocgst = Number(off * 0.01 * childObj.CGST);
        osgst = Number(off * 0.01 * childObj.SGST);
        tax = Number(childObj.amount * 0.01 * childObj.CGST)+ Number(childObj.amount * 0.01 * childObj.SGST);
        cgst = Number(childObj.amount * 0.01 * childObj.CGST);
        sgst = Number(childObj.amount * 0.01 * childObj.SGST);
        off = Number(off) + Number(off * 0.01 * childObj.CGST)+ Number(off * 0.01 * childObj.SGST);
        childObj.amount = Number(childObj.amount) + Number(childObj.amount * 0.01 * childObj.CGST)+ Number(childObj.amount * 0.01 * childObj.SGST);

      }else if(childObj.IGST){

        offtax = Number(off * 0.01 * childObj.IGST);

        tax = Number(childObj.amount * 0.01 * childObj.IGST);
        off = Number(off) + Number(off * 0.01 * childObj.IGST);
        oigst = Number(off * 0.01 * childObj.IGST);
        console.log(oigst);
        iigst = Number(childObj.amount * 0.01 * childObj.IGST);
        console.log(igst);
        childObj.amount = Number(childObj.amount) + Number(childObj.amount * 0.01 * childObj.IGST);

      }
    }

      let data = {'weight':0,'price':childObj.amount,'goldcat':'','oigst':oigst,'osgst':osgst,'ocgst':ocgst,'igst':iigst,'sgst':sgst,'cgst':cgst,'offtax':offtax,'tax':tax,'goldweight':0,'making':0,'off':off};
      priceWeight.push(data);


    }  else
    {
      priceProduct = Math.round(priceProduct);
      if(childObj.offer_type == 'Percentage')
      {

        off = Number(priceProduct)-Number(priceProduct*0.01*childObj.offer_amount);
      }else if(childObj.offer_type == "Flat")
      {
        off = Number(priceProduct)- Number(childObj.offer_amount);
      }

      if(childObj.offer_type == 'Percentage' || childObj.offer_type == "Flat"){
      if(!igst && childObj.CGST && childObj.SGST){

        offtax = Number(off * 0.01 * childObj.CGST)+ Number(off * 0.01 * childObj.SGST);
        osgst = Number(off * 0.01 * childObj.SGST);
        ocgst = Number(off * 0.01 * childObj.CGST);
        tax = Number(priceProduct * 0.01 * childObj.CGST) +  Number(priceProduct * 0.01 * childObj.SGST);
        cgst = Number(priceProduct * 0.01 * childObj.CGST);
        sgst = Number(priceProduct * 0.01 * childObj.SGST);
        off = Number(off) + Number(off * 0.01 * childObj.CGST)+ Number(off * 0.01 * childObj.SGST);
        priceProduct = Number(priceProduct);

      }else if(childObj.IGST){

        offtax = Number(off * 0.01 * childObj.IGST);
        oigst = Number(offtax);
        console.log(oigst);
        tax = Number(priceProduct * 0.01 * childObj.IGST);
        iigst = Number(tax);
        console.log(igst);
        off = Number(off) + Number(off * 0.01 * childObj.IGST);
        priceProduct = Number(priceProduct);

      }
    }else{
        if(!igst && childObj.CGST && childObj.SGST){

          offtax = Number(off * 0.01 * childObj.CGST)+ Number(off * 0.01 * childObj.SGST);
          osgst = Number(off * 0.01 * childObj.SGST);
          ocgst = Number(off * 0.01 * childObj.CGST);
          tax = Number(priceProduct * 0.01 * childObj.CGST) +  Number(priceProduct * 0.01 * childObj.SGST);
          cgst = Number(priceProduct * 0.01 * childObj.CGST);
          sgst = Number(priceProduct * 0.01 * childObj.SGST);
          off = Number(off) + Number(off * 0.01 * childObj.CGST)+ Number(off * 0.01 * childObj.SGST);
          priceProduct = Number(priceProduct) + Number(priceProduct * 0.01 * childObj.CGST) +  Number(priceProduct * 0.01 * childObj.SGST);

        }else if(childObj.IGST){

          offtax = Number(off * 0.01 * childObj.IGST);
          oigst = Number(offtax);
          console.log(oigst);
          tax = Number(priceProduct * 0.01 * childObj.IGST);
          iigst = Number(tax);
          console.log(igst);
          off = Number(off) + Number(off * 0.01 * childObj.IGST);
          priceProduct = Number(priceProduct) + Number(priceProduct * 0.01 * childObj.IGST);
        }
      }


      if(gold){
        let data = {'weight':weight.toFixed(3),'price':priceProduct,'offtax':offtax,'tax':tax,'oigst':oigst,'osgst':osgst,'ocgst':ocgst,'igst':iigst,'sgst':sgst,'cgst':cgst,'goldcat':gold.materialType,'goldweight':goldweight,'making':making,'off':off};
        priceWeight.push(data);}
        else{
          let data = {'weight':weight.toFixed(3),'price':priceProduct,'offtax':offtax,'tax':tax,'oigst':oigst,'osgst':osgst,'ocgst':ocgst,'igst':iigst,'sgst':sgst,'cgst':cgst,'goldcat':'','goldweight':0,'making':making,'off':off};
        priceWeight.push(data);}


    }
    });
    return priceWeight;
  }

  price(weight, rate, option, makingcharge, wastage = 0, value = 0, quantity=0) {
    let metalprice = 0;
    let making = 0;
    if  (option == "PerGram") {
        metalprice  =  (Number(rate) + Number(makingcharge)) * Number(weight);
        making = Number(makingcharge) * Number(weight);
    } else if (option == "Percentage") {
    weight = ((Number(makingcharge) + Number(value)) / 100) * Number(weight);
    metalprice = Number(rate) * weight;
    } else if (option == "Fixed") {
        metalprice = Number(weight) * Number(rate) + Number(makingcharge);
        making = Number(makingcharge);
    } else if  (option == "Perpiece") {
      metalprice  =  Number(rate) * Number(weight);
      metalprice += Number(makingcharge) * Number(quantity);
      making = Number(makingcharge) * Number(weight);
    }
    if (wastage != 0) {
      let wasteprice = ((Number(weight) / 100) *  Number(wastage)) * Number(rate);
      metalprice = metalprice + wasteprice;
   }
    let data = {'weight': weight,'price': metalprice,'making_charge':making};
    return data;
  }
  setfilter(value)
  {
    this.filter = value;
    //localStorage.setItem('filter',JSON.stringify(value));
    this.filterChange.emit("filterchanged"+Date.now());
  }
  getfilter()
  {
    return this.filter;
   // return JSON.parse(localStorage.getItem('filter'));
  }

  public encrypt(data) {
    // console.log(JSON.stringify(data));
    const encryptedMessage = CryptoJS.AES.encrypt(JSON.stringify(data), 'test').toString();
    return encryptedMessage;
   }

   public decrypt(data) {
     const decryptedMessage = CryptoJS.AES.decrypt(data, 'test');
     return JSON.parse(decryptedMessage.toString(CryptoJS.enc.Utf8));
    }

    updateCart()
    {
      if(localStorage.getItem('savya_userInfo'))
      {
       let u=this.getUserInfo();
      this.uid=u.id;
      this.Get(CARTVIEW+"?user_id="+this.uid).then(data=>{
        //console.log(data['data'][0].cart_id);
        console.log( data);
        localStorage.setItem('cart',JSON.stringify(data));
      }).catch(d=>{
        if( d.status == 503){
          this.onFail('Your session is expired please login again','Login');
          this.setGoto();
          this.setlogin(0);
          this.logout();
          setTimeout(() => {
          this.router.navigate(['/login']);
          },1000);
        } else{
        console.log(d);
        localStorage.removeItem('cart');
        this.Cart.emit("emptycart"+Date.now());}
      })
      console.log(this.uid);
     }



      //console.log("in update cart function")

    }
    checkCart(pid)
    {
      //console.log("pid =" + pid)
          let cart=this.getCart();
         // console.log(cart);
          if(cart)
          {
                  let result=cart.find(x => x.product_id == pid);

               // console.log(result);
                  if(result)
                  {
                 //  console.log("present");
                    return true;

                  }
                  else
                  {
                 // console.log("inner else not present");
                    return false;

                  }
            }
            else{
             // console.log(" external else not present");
              return false;
            }
    }
  getCart()
  {
    let m=localStorage.getItem('cart');
    if(m)
    {
      let n=JSON.parse(localStorage.getItem('cart'));
      return n['data'];
    }
    else{
      return null;
    }
  }
  qtyUpdate(pid,value)
  {
    console.log("in qtyupdate function");
    console.log("value="+value);
     let cart=this.getCart();
     if(cart)
     {
             let result=cart.find(x => x.product_id == pid);
             console.log(result);
             if(result)
             {
                  let cartId=result.cart_id;
                  let c=Number(result.count);

                  if(c==1&&value==-1)
                  {
                    this.deleteCart(pid);
                  }
                  else
                  {
                        c=c+value;
                     // this.Put2(CARTUPDATE+"?cart_id="+cartId+"&user_id="+this.uid+"&count="+c).then(data=>{
                       this.Put2(CARTUPDATE,"",{cart_id:cartId,user_id:this.uid,count:c}).then(data=>{

                        this.updateCart();
                        this.Cart.emit("cartUpdate"+Date.now());
                      }).catch(d=>{
                        if( d.status == 503){
                          this.onFail('Your session is expired please login again','Login');
                          this.setGoto();
                          this.setlogin(0);
                          this.logout();
                          setTimeout(() => {
                          this.router.navigate(['/login']);
                          },1000);
                        } else{console.log(d)}
                      });
                  }
              }
       }
  }

    deleteCart(pid)
    {
      console.log(pid)

      this.Delete(CARTDELETE+"?cart_id="+pid+"&user_id="+this.uid).then(data=>{
        //console.log("deletecart"+data)
        this.updateCart();
        this.Cart.emit("cartUpdated"+Date.now());
        this.onSuccess('Product Successfully Removed from the cart','Product Removed');

      }).catch(d=>{
        if( d.status == 503){
          this.onFail('Your session is expired please login again','Login');
          this.setGoto();
          this.setlogin(0);
          this.logout();
          setTimeout(() => {
          this.router.navigate(['/login']);
          },1000);
        } else{
        this.updateCart();
        console.log(d);
        this.Cart.emit("cartUpdated"+Date.now());}

      });

    }
    addToCart(product)
    {
     console.log(product);
      this.Post(CARTADD, product).then(data=>{
        console.log(data);
        this.updateCart();
        this.Cart.emit("cartUpdated"+Date.now());

      this.onSuccess('Product Successfully added to the cart','Product Added');
      //  localStorage.setItem('cart',JSON.stringify(data));
      }).catch(d=>{
        if( d.status == 503){
          this.onFail('Your session is expired please login again','Login');
          this.setGoto();
          this.setlogin(0);
          this.logout();
          setTimeout(() => {
          this.router.navigate(['/login']);
          },1000);
        } else{
        console.log(d);
        this.Cart.emit("cartUpdated"+Date.now());
        }
      });
    }



  //wishlist functions


    godetail(value) {
      if (value >= 0) {
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/product-details', value]);
      });
               }
              }
    updateWishlist()
    {
      this.Get(WISHLISTVIEW).then(data=>{
        console.log(data);
        localStorage.setItem('wishlist',JSON.stringify(data));
        this.heartLoader = false;
      }).catch(d=>{
        this.heartLoader = false;
        if( d.status == 503){
          this.onFail('Your session is expired please login again','Login');
          this.setGoto();
          this.setlogin(0);
          this.logout();
          setTimeout(() => {
          this.router.navigate(['/login']);
          },1000);
        } else{
          console.log(d);
          //console.log("deleteWishllist"+d.error.data);
        localStorage.removeItem('wishlist');
        this.getWish.emit("emptyWishlist"+Date.now())
        }
        ;
      })
    }

    deleteWishlist(pid)
    {
        console.log("wishlistdeletefunction")
        this.heartLoader = true;
        this.Delete(WISHLISTDELETE+"/"+pid).then(data=>{
          console.log(data);
         this.updateWishlist();
        //  this.onSuccess('Product Successfully Removed from the Wishlist','Product Removed');
         this.getWish.emit("wishlist updated"+Date.now());
        }).catch(d=>{
          this.heartLoader = false;
          if( d.status == 503){
            this.onFail('Your session is expired please login again','Login');
            this.setGoto();
            this.setlogin(0);
            this.logout();
            setTimeout(() => {
            this.router.navigate(['/login']);
            },1000);
          } else{
           console.log(d);}
         });

    }

  checkWishlist(pid)
  {
     // console.log("check"+pid);

      this.wish=this.getWishlist();
      if(this.wish)
      {
              let result=this.wish.find(x => x.product_id === pid);
          //  console.log("result="+result);
              if(result)
              {
                console.log("product already exist ");
              }
              else
              {
                this.heartLoader = true;
                this.Post(WISHLISTADD,{product_id:pid}).then(data=>{
                  console.log(data);
                     this.updateWishlist();
                    //  this.onSuccess('Product Successfully added to the Wishlist','Added');
                }).catch(d=>{
                  this.heartLoader= false;
                  if( d.status == 503){
                    this.onFail('Your session is expired please login again','Login');
                    this.setGoto();
                    this.setlogin(0);
                    this.logout();
                    setTimeout(() => {
                    this.router.navigate(['/login']);
                    },1000);
                  } else{
                   console.log(d);}
                 });
              }
        }
        else{
          this.Post(WISHLISTADD,{product_id:pid}).then(data=>{
            console.log(data);
               this.updateWishlist();
              //  this.onSuccess('Product Successfully added to the Wishlist',"Product Added");
          }).catch(d=>{
            if( d.status == 503){
              this.onFail('Your session is expired please login again','Login');
              this.setGoto();
              this.setlogin(0);
              this.logout();
              setTimeout(() => {
              this.router.navigate(['/login']);
              },1000);
            } else{
             console.log(d);}
           });
        }
  }
  getWishlist()
  {
    let m=localStorage.getItem('wishlist');
    if(m)
    {
      let n=JSON.parse(localStorage.getItem('wishlist'));
      return n['data'];
    }
    else{
      return null;
    }

  }

  setUserInfo(value)
  {
   let e=this.encrypt(value);
    localStorage.setItem('savya_userInfo',e);

  }

  updateOrderHistory()
  {
    this.Post(ORDERHISTORY,{user_id:this.uid}).then(data=>{
      console.log( data);
      localStorage.setItem('orders',JSON.stringify(data['data']));
    }).catch(d=>{
      if( d.status == 503){
        this.onFail('Your session is expired please login again',"Login Again");
        this.setGoto();
        this.setlogin(0);
        this.logout();
        setTimeout(() => {
        this.router.navigate(['/login']);
        },1000);
      } else{
      console.log(d);
      localStorage.removeItem('orders');}
    });
  }

}
